import React from 'react'
import { CircularProgress } from '@material-ui/core'

function Loading() {
    return <CircularProgress />
}

export default Loading
